module.exports = __webpack_public_path__ + "img/icon-informac-black.05d59c41.svg";